<template>
  <div class="container-fluid">
    <Header/>

    <div class="container">
      <div class="row page-name">
        <h2>All Quizes</h2>
      </div>

      <div class="row spinner justify-content-center align-items-center" v-if="spinner">
        <img src="../assets/images/spinner.svg" alt>
      </div>

      <div class="row quiz mt-3" v-for="(quiz, index) in allQuizes" :key="index">
        <div class="date d-flex align-items-center">
          <div class="col-auto">
            <p>{{quiz.date}}</p>
          </div>

          <div class="col line"></div>
        </div>

        <div class="body mt-3 d-flex flex-column align-items-center">
          <div class="blue-decor"></div>

          <div class="col top d-flex align-items-center">
            <div class="quiz-number mr-2">{{quiz.quizNumber}}</div>
            <div class="line"></div>
            <div class="quiz-name ml-2">{{quiz.subject}}</div>
          </div>

          <div
            class="col bottom"
          >Questions: {{quiz.questionsAmount}}, Time limit: {{quiz.timeLimit}}</div>

          <div class="section">SEC 001</div>
        </div>
      </div>
    </div>

    <Fab url="/addQuiz" tooltip="Add Quiz"></Fab>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Fab from "@/components/Fab.vue";

export default {
  name: "AllQuizes",
  data() {
    return {
      spinner: true,
      allQuizes: []
    };
  },
  components: {
    Header,
    Fab
  },
  methods: {
    getAllQuizes() {
      const teacherData = JSON.parse(sessionStorage.getItem("teacherData"));

      axios
        .get(`${apiUrl}/quiz/${teacherData.subjects[0].name}`)
        .then(res => {
          this.spinner = false;

          this.allQuizes = res.data.quizes.map(quiz => {
            const date = new Date(quiz.date);
            const [, month, day] = date.toString().split(" ");

            return {
              date: `${month} ${day}`,
              questionsAmount: quiz.questions.length,
              quizNumber: quiz.quizNumber,
              subject: quiz.subject.name,
              timeLimit: quiz.timeLimit
            };
          });
        })
        .catch(err => null);
    }
  },
  created() {
    this.getAllQuizes();
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.container-fluid {
  padding: 0;
}

.spinner {
  height: 70vh;
}

.container {
  padding: 1.8rem 0;
}

.page-name h2 {
  color: $black;
}

.quiz {
  .date {
    width: 100%;

    p {
      color: $greyLight;
      font-weight: 500;
    }

    .line {
      width: 90%;
      border-bottom: 1px solid $greyLight;
    }
  }

  .body {
    background-color: #efeff0;
    border-radius: $borderRadius;
    position: relative;
    width: 100%;
    height: 100px;
    padding: 10px 35px;

    .top {
      .quiz-number {
        color: $green;
        font-weight: bold;
        font-size: 1.4rem;
      }

      .line {
        height: 25px;
        border-right: 1px solid $greyLight;
      }

      .quiz-name {
        color: $greyDarker;
        font-weight: bold;
        font-size: 1.4rem;
      }
    }

    .bottom {
      color: $blueLight;
      font-size: 1rem;
      font-weight: 700;
    }

    .blue-decor {
      top: 0;
      left: 0;
      background-color: $blueLight;
      border-radius: $borderRadius 0 0 $borderRadius;
      width: 12px;
      height: 100%;
      position: absolute;
    }

    .section {
      color: #fff;
      padding: 4px 10px;
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: $green;
      border-radius: $borderRadius 0 $borderRadius 0;
      font-weight: 500;
    }
  }
}
</style>

